<template>
    <div class="device-type-manange relative">
        <div class="buttons">
            <el-button @click="addData">新增</el-button>

        </div>

        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24"  style="margin-bottom:10px;">
                <span class="fs-14 pd-r-10">模板名称：</span>
                <el-input v-model="sms_name" placeholder="模板名称模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24"  style="margin-bottom: 10px;">
                <span class="fs-14 pd-r-10">模板内容：</span>
                <el-input v-model="sms_content" placeholder="模板内容模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <el-button @click="search">筛选</el-button>
                <el-button @click="resetForm">重置</el-button>
            </el-col>
        </el-row>

        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  style="width: 100%">
            <el-table-column width="50" prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="200" prop="name" label="名称" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="100" prop="sms_type" label="短信类型" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="content" label="短信内容" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="100" prop="status_txt" label="状态" align="center" label-class-name="label" v-slot="scope">
                <span style="color: #ff3333;" v-if="scope.row.flow_status == 'Reject'">{{ scope.row.status_txt }}</span>
                <span v-else>{{ scope.row.status_txt }}</span>
            </el-table-column>
            <el-table-column width="300" style="color: #ff3333;" prop="review_desc" label="审核说明" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="160" prop="create_date" label="添加时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="120" label="操作" align="center" label-class-name="label" v-slot="scope">
                <el-button @click="goEdit(scope.row)" type="text" size="mini" v-if="scope.row.flow_status==='Reject'">编辑</el-button>
                <el-button @click="deleteData(scope.row)" type="text" size="mini">删除</el-button>
                <el-button @click="startStopTitle(scope.row,2)"
                           v-if="scope.row.flow_status==='Adopted' && scope.row.status == 1"
                           type="text"
                           size="small">停用
                </el-button>
                <el-button @click="startStopTitle(scope.row,1)"
                           v-if="scope.row.flow_status==='Adopted' && scope.row.status == 2"
                           type="text"
                           size="small">启用
                </el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>

        <el-dialog
            :title="dialog_title"
            :visible.sync="dialogVisible"
            width="30%"
            center>
                <el-form label-position="right" :model="userForm" :rules="userRules" ref="userForm"
                         label-width="80px"
                         class="form" style="width: 90%;margin: 20px auto 0 auto;" autocomplete="off">
                    <el-form-item label="问候短信" prop="template_id" style="margin-bottom: 0;">
                        <el-select v-model="userForm.template_type" placeholder="请选择短信类型"
                                   style="width: 100%;">
                            <el-option
                                v-for="item in allTemplatetype"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="模板名称" prop="name">
                        <el-input type="text" v-model="userForm.name" placeholder="请输入模板名称" autocomplete="off"
                                  style="width: calc(100% - 10px);"></el-input>
                    </el-form-item>
                    <el-form-item label="短信内容" prop="content">
                        <el-input type="textarea" v-model="userForm.content"
                                  maxlength="500"
                                  show-word-limit
                                  rows="5" @blur="cntCheck('blur')" @focus="cntCheck('focus')" placeholder="请输入短信内容" autocomplete="off"
                                  style="width: calc(100% - 10px);"></el-input>
                        <div class="el-form-item__error">短信条数：{{sms_num}}</div>
                    </el-form-item>
                    <el-form-item label="申请说明" prop="remark">
                        <el-input type="textarea" v-model="userForm.template_desc" placeholder="请输入申请说明" autocomplete="off"
                                  style="width: calc(100% - 10px);"></el-input>
                    </el-form-item>

                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="success" @click="addSmsTmpl('userForm')">保存</el-button>
                </div>
        </el-dialog>
    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";

    export default {
        data() {
            // 模板名称验证
            let checkName = (rule, value, callback) => {
                setTimeout(() => {
                    if (!(/^[\u4E00-\u9FA5A-Za-z0-9_]+$/).test(value.slice(0, 1))) {
                        callback(new Error('只能包含中文、英文、数字、下划线'));
                    } else {
                        callback();
                    }
                }, 1);
            };
            return {
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                is_submit: false,
                dialog_title: '新增短信模板',
                dialogVisible: false,
                sms_name:'',
                sms_content:'',
                userForm: {
                    id: '',
                    name: '',
                    content: '',
                    template_desc: '',
                    template_type: 'PROMOTION_TYPE',
                },
                userRules: {
                    name: [
                        {required: true, message: "请输入模板名称", trigger: "blur"},
                        {validator: checkName, trigger: "blur"}
                    ],
                    content: [
                        {required: true, message: "请输入短信内容", trigger: "blur"},
                    ],
                },
                allTemplatetype: [
                    // {
                    //     id: 'NOTIFY_TYPE',
                    //     name: '通知短信'
                    // },
                    {
                        id: 'PROMOTION_TYPE',
                        name: '推广短信'
                    },
                ],
                sms_num: 1,
            };
        },
        created() {

        },
        mounted() {
            // 获取分类列表
            this.getList();
        },
        methods: {
            cntCheck(type) {
                if (type === 'blur' && this.userForm.template_type === 'PROMOTION_TYPE' && this.userForm.content.indexOf('拒收请回复R') < 0) {
                    this.userForm.content = this.userForm.content + ' 拒收请回复R'
                } else if (type === 'focus' && this.userForm.template_type === 'PROMOTION_TYPE') {
                    this.userForm.content = this.userForm.content.replaceAll(' 拒收请回复R', '')
                    this.userForm.content = this.userForm.content.replaceAll('拒收请回复R', '')
                }
                let content_len = this.userForm.content.length + 5
                if (content_len <= 70) {
                    this.sms_num = 1;
                } else {
                    this.sms_num = Math.ceil(content_len / 67)
                }
            },
            // 获取所有医生
            getList() {
                let params = {
                    servername: 'Ruyi_AdminNewOperateServices',
                    method: 'smsTmplList',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        sms_name: this.sms_name,
                        sms_content: this.sms_content,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    for (var i = 0; i < res.data.data.list.length; i++) {
                        // 序号
                        res.data.data.list[i].no = (this.page - 1) * this.perpage + i + 1
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                });
            },
            addSmsTmpl(formName) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复提交',
                        duration: 1500,
                    });
                    return;
                }

                this.is_submit = true;
                let _that = this
                let message = '添加成功';
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let params = {
                            'servername': 'Ruyi_AdminNewOperateServices',
                            'method': 'createSmsTmpl',
                            'params': {
                                id: this.userForm.id,
                                name: this.userForm.name,
                                template_desc: this.userForm.template_desc,
                                content: this.userForm.content,
                                template_type: this.userForm.template_type,
                            }
                        };
                        if (this.userForm.id) {
                            params.method = 'updateSmsTmpl'
                            message = '编辑成功'
                        }
                        this.$api.service(params).then(res => {
                            if (!check(res)) {
                                this.is_submit = false;
                                return;
                            }
                            this.$message({
                                type: "success",
                                message: message,
                                duration: 1500,
                                onClose: function () {
                                    _that.is_submit = false;
                                    _that.dialogVisible = false;
                                    _that.getList()
                                    return;
                                }
                            });
                        }).finally(() => {
                            this.is_submit = false;
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: '请输入必填项'
                        });
                        this.is_submit = false;
                        return false;
                    }
                })
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },
            resetForm(){
                this.sms_content = ''
                this.sms_name = ''
                this.page = 1
                this.perpage = 10
                this.getList()
            },
            search(){
                this.getList()
            },
            // 编辑模板
            goEdit(data) {
                this.dialog_title = `编辑短信模板：${data.name}`;
                this.userForm.name= data.name
                this.userForm.content= data.content
                this.userForm.template_desc= data.template_desc
                this.userForm.id = data.id
                this.dialogVisible = true
            },

            // 新增模板
            addData() {
                this.dialog_title = '新增短信模板'
                this.userForm.name= ''
                this.userForm.content= ''
                this.userForm.template_desc= ''
                this.userForm.id =''
                this.dialogVisible = true
            },

            deleteData(data) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.$confirm(`确定删除短信模板：${data.name}？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_AdminNewOperateServices',
                        method: 'deleteSmsTmpl',
                        params: {
                            id: data.id,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }
                        if (res.data.code != '0') {
                            this.$message({
                                type: "error",
                                message: res.data.msg,
                                duration: 1500,
                            });
                        } else {
                            this.$message({
                                type: "success",
                                message: '删除成功',
                                duration: 1500,
                            });
                        }
                        this.is_submit = false;
                        this.getList();
                    }).catch(() => {
                        this.is_submit = false;
                    }).finally(() => {
                        this.is_submit = false;
                    });
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },

            // 启用停用短信模板
            startStopTitle(data, status) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                let message = null;
                if (status == '1') {
                    message = `确定启用短信模板：${data.name}？`;
                }
                if (status == '2') {
                    message = `确定停用短信模板：${data.name}？`;
                }
                this.$confirm(message, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_AdminNewOperateServices',
                        method: 'startStopSmsTmpl',
                        params: {
                            id: data.id,
                            status: status
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: '修改成功',
                            duration: 1500,
                        });
                        this.getList();
                        this.is_submit = false;
                    }).catch(() => {
                        this.is_submit = false;
                    });
                }).catch(() => {
                    this.is_submit = false;
                });
            },


        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }
</style>
